(() => {
  const source = document.querySelector('[data-nexbie-product-analytics]');
  if (!source) return;
  const product = JSON.parse(source.textContent);
  const queue = []; let ready = false; let stopped = false; let nextSendAt = Infinity;
  const started = Date.now(); const debug = new URLSearchParams(location.search).has('preview_theme_id') || new URLSearchParams(location.search).get('debug') === '1';
  function readyConfig() { return typeof window.gtag === 'function' && (window.dataLayer || []).some(row => row?.[0] === 'config' && row?.[1] === 'G-KE48RMVXE4'); }
  function flush(urgent = false) {
    if (stopped) return;
    if (!ready && readyConfig()) { ready = true; nextSendAt = Date.now() + 1000; }
    if (!ready) return;
    while (queue.length && (urgent || Date.now() >= nextSendAt)) { const [name, params] = queue.shift(); window.gtag('event', name, params); nextSendAt = Date.now() + 300; if (!urgent) break; }
  }
  function track(name, params = {}) {
    if (stopped) return;
    const safe = { product_id: String(product.id), product_handle: product.handle, currency: product.currency, ...params };
    if (debug) safe.debug_mode = true;
    for (const key of Object.keys(safe)) if (typeof safe[key] === 'string') safe[key] = safe[key].slice(0, 100);
    queue.push([name, safe]); flush();
  }
  const timer = setInterval(() => { flush(); if (!ready && Date.now() - started > 30000) { stopped = true; queue.length = 0; clearInterval(timer); } }, 100);
  function selected() {
    const id = document.querySelector('product-info form[action*="/cart/add"] input[name="id"]')?.value;
    const variant = product.variants.find(v => String(v.id) === id) || product.variants[0];
    const quantity = Number(document.querySelector('product-info input[name="quantity"]')?.value || 1);
    return { variant_id: String(variant.id), quantity, value: variant.price / 100 * quantity };
  }
  track('pdp_view_item', { value: product.price / 100, items: [{ item_id: String(product.variant), item_name: product.title, item_brand: product.vendor, price: product.price / 100, quantity: 1 }] });
  const reached = new Set();
  const scroll = () => { const range = document.documentElement.scrollHeight - innerHeight; const depth = range <= 0 ? 100 : Math.min(100, (scrollY / range) * 100); for (const mark of [25, 50, 75, 90, 100]) if (depth >= mark && !reached.has(mark)) { reached.add(mark); track('pdp_scroll_depth', { percent: mark }); } };
  addEventListener('scroll', scroll, { passive: true }); scroll();
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const el = event.target;
    if (el.closest('product-info .product-form__submit')) track('pdp_add_to_cart_click', selected());
    else if (el.closest('product-info .shopify-payment-button')) track('pdp_buy_now_click', selected());
    else if (el.closest('media-gallery button, product-modal button')) track('pdp_image_click', { action: 'gallery' });
    else if (el.closest('.jdgm-widget')) track('pdp_review_interaction', { action: 'click' });
    else if (el.closest('product-recommendations a[href*="/products/"]')) track('pdp_recommendation_interaction', { action: 'click' });
  }, true);
  document.addEventListener('play', event => { if (event.target instanceof HTMLVideoElement) track('pdp_video_interaction', { action: 'play' }); }, true);
  document.addEventListener('nexbie:cart-result', event => {
    const result = event.detail || {};
    const variant = product.variants.find(v => String(v.id) === String(result.productVariantId));
    if (!variant || !event.target.closest('product-info')) return;
    const quantity = Number(result.quantity || 1);
    if (result.ok) {
      const item = result.cartData?.items?.find(v => String(v.variant_id) === String(variant.id)) || result.cartData;
      track('pdp_add_to_cart_success', { variant_id: String(variant.id), quantity, value: (item?.final_price ?? variant.price) / 100 * quantity });
    } else {
      track('pdp_add_to_cart_fail', { variant_id: String(variant.id), reason: result.reason || 'request_error' });
    }
  });
  let visibleAt = document.visibilityState === 'visible' ? Date.now() : null; let elapsed = 0;
  function leave() { if (visibleAt !== null) { elapsed += Date.now() - visibleAt; visibleAt = null; track('pdp_engagement_time', { engagement_time_msec: elapsed }); elapsed = 0; } flush(true); }
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') leave(); else visibleAt = Date.now(); });
  addEventListener('pagehide', leave);
})();
